export default __webpack_public_path__ + "static/media/i-preview.a114fd8e.webp";